import { useState } from 'react';
import { api, formatApiError } from '../lib/api';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Phone, Loader2, ExternalLink } from 'lucide-react';

export function WhatsAppPostPurchaseButton({ orderType, orderId, className = '' }) {
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState(null);

  const handleClick = async () => {
    setLoading(true);
    try {
      const data = await api.getWhatsAppContact(orderType, orderId);
      setContactData(data);
      window.open(data.wa_link, '_blank');
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={className}>
      <Button
        onClick={handleClick}
        disabled={loading}
        className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-medium"
        data-testid={`whatsapp-btn-${orderType}-${orderId}`}
      >
        {loading ? (
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
        ) : (
          <Phone className="w-4 h-4 mr-2" />
        )}
        WhatsApp del criador
      </Button>
      {contactData && (
        <p className="text-xs text-zinc-500 mt-1.5 text-center">
          {contactData.seller_name} - {contactData.phone_display}
        </p>
      )}
    </div>
  );
}

export function DemoBadge() {
  return (
    <span className="absolute top-2 right-2 z-10 bg-amber-500/90 text-black text-[10px] font-bold px-2 py-0.5 rounded tracking-wider uppercase backdrop-blur-sm" data-testid="demo-badge">
      Demo
    </span>
  );
}

export function DemoWatermark() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[5]">
      <span className="text-white/20 text-4xl font-black tracking-[0.3em] uppercase rotate-[-25deg] select-none">
        PRUEBA
      </span>
    </div>
  );
}
